module.exports = __webpack_public_path__ + "static/confeti_right-3690a270dbd761d1a0eded1b388ce7bc.svg";